import { Suspense, lazy } from 'react';
import { MainAppMethods } from '../../App';

const Component = lazy(() => import("./UnreadMail"));

function UnreadMail(props: MainAppMethods) {

    return (
        <div>
            <Suspense fallback={<div>loading...</div>}>
              <Component getHeaders={props.getHeaders} onClose={props.onClose}  />
            </Suspense>
        </div>);

}

export default UnreadMail; 



